import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ListTable, TableFilters } from '../../uiComponents';
import {
  filters,
  maxMinFilters,
  searchInputInitialValues,
} from '../../../constants/MaxMin.const';
import labels from '../../../constants/labels.json';
import styles from './MinMaxSidebar.module.css';
import { getMaxMinTableByBranch } from '../../../appRedux/actions';
import { maxMinConst } from '../../../constants/Stock.const';

export const MinMaxSidebar = ({ setSidebarOpen }) => {
  const { branchId } = useSelector((state) => state.userAuth);
  const getTotalStock = useMemo(
    () => (record) =>
      record.stock?.reduce((total, item) => total + (item.quantity ?? 0), 0) ??
      0,

    [],
  );

  const getRangeLabel = useMemo(
    () => (record) => {
      const stock = getTotalStock(record);

      if (stock < record.min) return maxMinConst.belowMin;
      if (stock > record.max) return maxMinConst.aboveMax;

      return maxMinConst.inRange;
    },
    [getTotalStock],
  );

  const columns = [
    {
      title: 'SKU',
      dataIndex: 'sku',
      key: 'sku',
    },
    {
      title: 'Producto',
      dataIndex: 'productName',
      key: 'productName',
    },
    {
      title: 'Stock',
      key: 'stock',
      render: (_, record) => getTotalStock(record),
    },
    {
      title: 'Mínimo',
      dataIndex: 'min',
      key: 'min',
    },
    {
      title: 'Máximo',
      dataIndex: 'max',
      key: 'max',
    },
    {
      title: 'Rango',
      key: 'range',
      render: (_, record) => getRangeLabel(record),
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <span className={styles.title}>{labels.title_max_min}</span>
      </div>

      <TableFilters
        privileges={[]}
        searchFilters={maxMinFilters}
        filters={filters}
        searchInputInitialValues={searchInputInitialValues}
      />

      <ListTable
        columns={columns}
        getDataFunction={(params) => getMaxMinTableByBranch(branchId, params)}
        canExport={false}
      />
    </div>
  );
};
